/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { BigModal } from './BigModal';
import { ModalButton } from './ModalButton';
import { Typography, Box, Checkbox, FormControlLabel } from '@mui/material';
import { useState, useEffect } from 'react';
import { apiUrl } from '../../utilities/apiUrl';

export const ConsentModal = (props) => {
  const [consentValue, setConsentValue] = useState(false);
  const [consentFormPath, setConsentFormPath] = useState('');

  const getConsentFormPath = (path) => {
    try {
      return require(`../../${path}`);
    } catch (err) {
      console.error('Consent form not found for version:', version);
      return '';
    }
  };

  useEffect(() => {
    const fetchConsentForm = async () => {
      try {
        const response = await fetch(apiUrl('/eis/consentformversion/'), {
          method: 'GET',
          credentials: 'include',
        });

        const data = await response.json();
        if (data.success && data.data && data.data.path) {
          setConsentFormPath(getConsentFormPath(data.data.path));
        }
      } catch (err) {
        console.log(err);
      }
    };

    fetchConsentForm();
  }, []);

  // Open the next modal and cleanup the consent modal
  const handleSubmit = () => {
    props.openNextModal();
    setConsentValue(false);
    props.onClose();
  };

  return (
    <>
      <BigModal
        style={{ display: 'flex', flexDirection: 'column' }}
        width={'60%'}
        open={props.open}
        onClose={() => {
          props.onClose();
          setConsentValue(false);
        }}
      >
        <Typography sx={{ mb: 2, fontWeight: 600 }} variant="h5">
          Consent Form:
        </Typography>
        <Box
          sx={{
            height: '80vh',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box
            sx={{
              flex: 1,
              overflow: 'auto',
              borderRadius: 2,
            }}
          >
            <iframe
              src={consentFormPath}
              title="Consent Form"
              style={{
                width: '100%',
                height: '100%',
                border: 'none',
                borderRadius: 2,
              }}
            />
          </Box>

          <Typography sx={{ my: 2, fontWeight: 500, fontSize: '0.875rem' }}>
            By clicking “I Agree” or submitting this form, I confirm that I have
            read, understood, and voluntarily consent to the processing of my
            personal and sensitive personal information as described above.
          </Typography>

          <FormControlLabel
            sx={{
              width: 'fit-content',
              display: 'inline-flex',
            }}
            control={
              <Checkbox
                size="small"
                color="primary"
                checked={consentValue}
                onChange={(e) => setConsentValue(e.target.checked)}
              />
            }
            label={
              <Typography sx={{ fontSize: '0.875rem' }}>
                I agree to the processing of my personal information as
                described above.
              </Typography>
            }
          />
        </Box>
        <ModalButton
          primaryBtnName="Confirm"
          secondaryBtnName="Cancel"
          primaryClickHandler={() => {
            handleSubmit();
          }}
          secondaryClickHandler={() => {
            props.secondaryClick();
            setConsentValue(false);
          }}
          // Ensures all fields are properly filled before submit button becomes available
          disable={!consentValue}
        />
      </BigModal>
    </>
  );
};
